// SIDEBAR
import dashboard from "./sidebar/dashboard.svg";
import dashboard2 from "./sidebar/dashboard2.svg";
import report from "./sidebar/report.svg";
import report2 from "./sidebar/report2.svg";
import addon from "./sidebar/addon.svg";
import addon2 from "./sidebar/addon2.svg";
import stores from "./sidebar/stores.svg";
import stores2 from "./sidebar/stores2.svg";
import membership from "./sidebar/membership.svg";
import membership2 from "./sidebar/membership2.svg";
import plans from "./sidebar/plans.svg";
import plans2 from "./sidebar/plans2.svg";
import customers from "./sidebar/customers.svg";
import customers2 from "./sidebar/customers2.svg";
import users from "./sidebar/users.svg";
import users2 from "./sidebar/users2.svg";
import roles from "./sidebar/roles.svg";
import roles2 from "./sidebar/roles2.svg";
import settings from "./sidebar/settings.svg";
import settings2 from "./sidebar/settings2.svg";
import vehicles from "./sidebar/vehicles.svg";
import vehicles2 from "./sidebar/vehicles2.svg";
import notification from "./sidebar/notification.svg";
import notification2 from "./sidebar/notification2.svg";
import vehicleMake from "./sidebar/vehicleMake.svg";
import vehicleMake2 from "./sidebar/vehicleMake2.svg";
import vehicleModel from "./sidebar/vehicleModel.svg";
import vehicleModel2 from "./sidebar/vehicleModel2.svg";
import vehicleColor from "./sidebar/vehicleColor.svg";
import vehicleColor2 from "./sidebar/vehicleColor2.svg";
import sideBarCollapseOpen from "./sidebar/sideBarCollapseOpen.svg";
import sideBarCollapseClose from "./sidebar/sideBarCollapseClose.svg";
import storeCamera from "./sidebar/storeCamera.svg";
import storeCamera1 from "./sidebar/storeCamera1.svg";
import anprLogs from "./sidebar/anprLogs.svg";
import anprLogs2 from "./sidebar/anprLogs2.svg";
import auditLogs from "./sidebar/auditLogs.svg";
import auditLogs2 from "./sidebar/auditLogs2.svg";
import barrierControlLogs from "./sidebar/barrierControlLogs.svg";
import barrierControlLogs2 from "./sidebar/barrierControlLogs2.svg";
import kioskActivities from "./sidebar/kioskActivities.svg";
import kioskActivities2 from "./sidebar/kioskActivities2.svg";
import dynamicPrices from "./sidebar/dynamicPrices.svg";
import dynamicPrices2 from "./sidebar/dynamicPrices2.svg";
import logs from "./sidebar/logs.svg";
import logs2 from "./sidebar/logs2.svg";
import reportsIcon from "./sidebar/reportsIcon.svg";
import reportsIcon2 from "./sidebar/reportsIcon2.svg";
import transactionsIcon from "./sidebar/transactionsIcon.svg";
import transactionsIcon2 from "./sidebar/transactionsIcon2.svg";
import posTransactionsIcon from "./sidebar/posTransactionIcon.svg";
import posTransactionsIcon2 from "./sidebar/posTransactionIcon2.svg";
import sendSms from "./sidebar/sendSms.svg";
import sendSms2 from "./sidebar/sendSms2.svg";
import ratings from "./sidebar/ratings.svg";
import ratings2 from "./sidebar/ratings2.svg";

import washHistory from "./sidebar/washHistory.svg";
import washHistory2 from "./sidebar/washHistory2.svg";
import banners from "./sidebar/banners.svg";
import banners2 from "./sidebar/banners2.svg";
import rules from "./sidebar/rules.svg";
import rules2 from "./sidebar/rules2.svg";
import history from "./sidebar/history.svg";
import history2 from "./sidebar/history2.svg";
import pushNotification from "./sidebar/pushNotification.svg";
import pushNotification2 from "./sidebar/pushNotification2.svg";
import apiLogs from "./sidebar/apiLogs.svg";
import apiLogs2 from "./sidebar/apiLogs2.svg";
import profile from "./sidebar/profile.svg";
import profile2 from "./sidebar/profile2.svg";
import sidebarCollapse from "./sidebar/sidebarCollapse.svg";
import coupons from "./sidebar/coupons.svg";
import coupons2 from "./sidebar/coupons2.svg";
import qrLinks from "./sidebar/qrLogo.svg";
import qrLinks2 from "./sidebar/qrLogo2.svg";
import customerList from "./sidebar/customerList.svg";
import customerList2 from "./sidebar/customerList2.svg";
import leads from "./sidebar/leads.svg";
import leads2 from "./sidebar/leads2.svg";
import membershipLogs from "./sidebar/membershipLogs.svg";
import membershipLogs2 from "./sidebar/membershipLogs2.svg";
import codeLogo from "./sidebar/codeLogo.svg";
import codeLogo2 from "./sidebar/codeLogo2.svg";


// OTHERS
import refresh from "./refresh.svg";
import lightSearch from "./lightSearch.svg";
import trash from "./delete.svg";
import edit from "./edit.svg";
import view from "./view.svg";
import translate from "./translate.png";
import translateEnToAr from "./translate_en_to_ar.png";
import translateArToEn from "./translate_ar_to_en.png";
import logout from "./logout.svg";
import arrowRight from "./arrowRight.svg";
import info from "./info.svg";
import checkWhite from "./checkWhite.svg";
import plus from "./plus.svg";
import clock from "./clock.svg";
import closeSquare from "./closeSquare.svg";
import gridTypeTable from "./gridTypeTable.svg";
import listTypeTable from "./listTypeTable.svg";
import listTypeTable2 from "./listTypeTable2.svg";
import gridTypeTable2 from "./gridTypeTable2.svg";
// NO DATA FOUND
import noCustomers from "./noDataFound/customers.svg";
import noPlans from "./noDataFound/plans.svg";
import noRoles from "./noDataFound/roles.svg";
import noStores from "./noDataFound/stores.svg";
import noUsers from "./noDataFound/users.svg";
import noVehicles from "./noDataFound/vehicles.svg";
import noAddons from "./noDataFound/noAddons.svg";
import noPermission from "./noDataFound/noPermission.svg";
import noMembership from "./noDataFound/noMembership.svg";
import noWashHistory from "./noDataFound/noWashHistory.svg";
import noTransactions from "./noDataFound/noTransactions.svg";
// DASHBOARD ICONS
import activeWashes from "./dashboard/activeWashes.svg";
import appAdoption from "./dashboard/appAdoption.svg";
import avgWashTime from "./dashboard/avgWashTime.svg";
import queueWaitTime from "./dashboard/queueWaitTime.svg";
import totalRevenue from "./dashboard/totalRevenue.svg";
import totalVehicle from "./dashboard/totalVehicle.svg";
import tunnelStatus from "./dashboard/tunnelStatus.svg";
import vehiclesWashed from "./dashboard/vehiclesWashed.svg";
import weather from "./dashboard/weather.svg";
import systemUpTime from "./dashboard/systemUpTime.svg";
import ANPRSuccessRate from "./dashboard/ANPRSuccessRate.svg";
import manualIntervention from "./dashboard/manualIntervention.svg";
import emergencyExitActivated from "./dashboard/emergencyExitActivated.svg";
import carsExteriorTunnel from "./dashboard/carsExteriorTunnel.svg";
import carsInteriorTunnel from "./dashboard/carsInteriorTunnel.svg";
import abortedWashes from "./dashboard/abortedWashes.svg";
import totalCustomers from "./dashboard/totalCustomers.svg";
import newCustomer from "./dashboard/newCustomer.svg";
import churnRate from "./dashboard/churnRate.svg";
import appAdoptionRate from "./dashboard/appAdoptionRate.svg";
import newMembership from "./dashboard/newMembership.svg";
import retentionRate from "./dashboard/retentionRate.svg";
import customerLifetimeValue from "./dashboard/customerLifetimeValue.svg";
import usageRate from "./dashboard/usageRate.svg";
import totalRevenue2 from "./dashboard/totalRevenue2.svg";
import avgRevenuePerCar from "./dashboard/avgRevenuePerCar.svg";
import newTicket from "./dashboard/newTicket.svg";
import singleWashRevenue from "./dashboard/singleWashRevenue.svg";
import interiorRevenue from "./dashboard/interiorRevenue.svg";
import MPR from "./dashboard/MPR.svg";
import starBlack from "./dashboard/starBlack.svg";
import upgrade from "./dashboard/upgrade.svg";
import downgrade from "./dashboard/downgrade.svg";
import refreshDashboard from "./refreshDashboard.svg";

export const Icons = {
  dashboard,
  dashboard2,
  refresh,
  lightSearch,
  trash,
  edit,
  view,
  translate,
  translateEnToAr,
  translateArToEn,
  logout,
  report,
  report2,
  addon,
  addon2,
  stores,
  stores2,
  membership,
  membership2,
  customers,
  customers2,
  users,
  users2,
  roles,
  roles2,
  settings,
  settings2,
  vehicles,
  vehicles2,
  plans,
  plans2,
  arrowRight,
  info,
  noCustomers,
  noPlans,
  noRoles,
  noStores,
  noUsers,
  noVehicles,
  noAddons,
  noPermission,
  notification,
  notification2,
  checkWhite,
  vehicleMake,
  vehicleMake2,
  vehicleModel,
  vehicleModel2,
  vehicleColor,
  vehicleColor2,
  noWashHistory,
  noMembership,
  noTransactions,
  washHistory,
  washHistory2,
  banners,
  banners2,
  plus,
  rules,
  rules2,
  history,
  history2,
  pushNotification,
  pushNotification2,
  clock,
  closeSquare,
  gridTypeTable,
  listTypeTable,
  gridTypeTable2,
  listTypeTable2,
  activeWashes,
  appAdoption,
  avgWashTime,
  queueWaitTime,
  totalRevenue,
  totalVehicle,
  tunnelStatus,
  vehiclesWashed,
  weather,
  systemUpTime,
  ANPRSuccessRate,
  manualIntervention,
  emergencyExitActivated,
  carsExteriorTunnel,
  carsInteriorTunnel,
  abortedWashes,
  totalCustomers,
  newCustomer,
  churnRate,
  appAdoptionRate,
  newMembership,
  retentionRate,
  customerLifetimeValue,
  usageRate,
  totalRevenue2,
  avgRevenuePerCar,
  newTicket,
  singleWashRevenue,
  interiorRevenue,
  MPR,
  starBlack,
  upgrade,
  downgrade,
  apiLogs,
  apiLogs2,
  profile,
  profile2,
  sidebarCollapse,
  refreshDashboard,
  coupons,
  coupons2,
  qrLinks,
  qrLinks2,
  sideBarCollapseOpen,
  sideBarCollapseClose,
  storeCamera,
  storeCamera1,
  anprLogs,
  anprLogs2,
  auditLogs,
  auditLogs2,
  barrierControlLogs,
  barrierControlLogs2,
  kioskActivities,
  kioskActivities2,
  dynamicPrices,
  dynamicPrices2,
  logs,
  logs2,
  reportsIcon,
  reportsIcon2,
  transactionsIcon,
  transactionsIcon2,
  customerList,
  customerList2,
  leads,
  leads2,
  membershipLogs,
  membershipLogs2,
  codeLogo,
  codeLogo2,
  posTransactionsIcon,
  posTransactionsIcon2,
  sendSms,
  sendSms2,
  ratings,
  ratings2,
};
